import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';

import Header from '../../common/Header';
import Footer from '../../common/Footer';
import SeoHelmet from '../../common/SeoHelmet';

const ClayEffectiveFrictionAngleTheory = () => {
  return (
    <>
      <SeoHelmet
        title="GeoCalc | PI vs φ′ Relationships | Theory"
        description="Relationships between Plasticity Index (PI) and effective friction angle (φ′) based on Terzaghi, Peck & Mesri (1996), Kenny (1959), and Gibson (1953)."
        url="https://www.geocalc.app/clayEffectiveFrictionAngle-theory"
        image="https://www.geocalc.app/assets/og-theory-v1.jpg"
        schemaType="page"
        breadcrumbs={[
          { name: 'Home', url: 'https://www.geocalc.app/' },
          { name: 'PI vs φ′ Relationships | Theory', url: 'https://www.geocalc.app/clayEffectiveFrictionAngle-theory' },
        ]}
      />
      <Header />
      <div className="theory">
        <div className="theoryContainer clayEffectiveFrictionAngleTheory">
          <h1>PI vs φ' Relationships | Terzaghi, Peck, Mesri 1996 - Kenny 1959 - Gibson 1953 | Theory & Formulations</h1>

          <section>
            <h2>1. Terzaghi, Peck, and Mesri (1996)</h2>
            <ul>
              <li>Effective friction angle (φ′) of clayey soils decreases as Plasticity Index (PI) increases.</li>
              <li>Low PI clays (PI &lt; 15) → φ′ ≈ 30°–35°.</li>
              <li>High PI clays (PI &gt; 50) → φ′ ≈ 20°–25°.</li>
              <li>Higher plasticity → Lower shear strength → Lower φ′.</li>
              <li>Applicable mainly to normally consolidated and lightly overconsolidated clays.</li>
            </ul>
          </section>

          <section>
            <h2>2. Kenny (1959)</h2>
            <ul>
              <li>Proposed an empirical linear relationship between PI and φ′.</li>
              <li>
                General formula: <br />
                φ′ = 32° − 0.25 × PI
              </li>
              <li>Every increase of 4 in PI reduces φ′ by about 1 degree.</li>
              <li>Useful for quick preliminary soil evaluations.</li>
            </ul>
          </section>

          <section>
            <h2>3. Gibson (1953)</h2>
            <ul>
              <li>Studied remolded clays and found an inverse relationship between PI and φ′.</li>
              <li>Low PI clays → Higher φ′ (~30°–35°).</li>
              <li>High PI clays → Lower φ′ (~15°–20°).</li>
              <li>Loss of soil structure in remolded clays emphasizes plasticity’s impact on reducing shear strength.</li>
            </ul>
          </section>

          <section>
            <h2>Quick Takeaway</h2>
            <ul>
              <li>Across all studies, as PI increases, φ′ decreases.</li>
              <li>High plasticity = weaker soils with lower internal friction angles.</li>
              <li>
                These correlations are suitable for preliminary design but should be confirmed by laboratory tests for critical
                projects.
              </li>
            </ul>
          </section>

          <div className="theoryButtonContainer">
            <Link to="/calculations/clayEffectiveFrictionAngle">
              <Button variant="outlined" size="small">
                GO TO CALCULATOR
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ClayEffectiveFrictionAngleTheory;
